import { IS_NON_US_SUGGESTIONS_COMPLIANCE_ENABLED } from '@/features/flags';
import { isUSMarket } from '@/helpers/getRegion';

/**
 * `check_guidelines` and the Tools-card CDS shortcuts use advisory
 * framing ("flag anything that deviates…", "anything unsafe for them
 * specifically"). Hide them for Tier 2/3 when the non-US compliance
 * rollout flag is on — same dual-gate as homepage suggestions.
 *
 * Shared by the note selection menu and the Scribe Tools-card Medication
 * Check / Guideline Check rows so those surfaces cannot drift.
 */
export const isSelectionCheckGuidelinesAllowed = (): boolean =>
  !(IS_NON_US_SUGGESTIONS_COMPLIANCE_ENABLED() && !isUSMarket());
